export default {
  base_url: '/api/illustrator/profile/portfolio/search-terms',

  all() {
    return axios.get(this.base_url).then(response => response.data);
  }
};